import { render, staticRenderFns } from "./edittag.vue?vue&type=template&id=69869d66&scoped=true"
import script from "./edittag.vue?vue&type=script&lang=js"
export * from "./edittag.vue?vue&type=script&lang=js"
import style0 from "./edittag.vue?vue&type=style&index=0&id=69869d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69869d66",
  null
  
)

export default component.exports